import Vue from 'vue'
import App from './App.vue'
import router from './router'
import VeeValidate from 'vee-validate';
import axios from 'axios';
import {TokenService} from './services/token.service'
import { store } from './store'

import BootstrapVue from 'bootstrap-vue'
import './custom.scss'
import 'core-js/es6/symbol';
import 'core-js/es6/object';
import 'core-js/es6/function';
import 'core-js/es6/parse-int';
import 'core-js/es6/parse-float';
import 'core-js/es6/number';
import 'core-js/es6/math';
import 'core-js/es6/string';
import 'core-js/es6/date';
import 'core-js/es6/array';
import 'core-js/es6/regexp';
import 'core-js/es6/map';
import 'core-js/es6/weak-map';
import 'core-js/es6/set';

import Home from './views/Home.vue'
import HomeLoggedIn from './views/HomeLoggedIn.vue'

import PageEditor from './views/admin/PageEditor.vue'
import SearchLog from './views/admin/SearchLog.vue'

// register views
import Register from './views/account/Register.vue'
import RegisterSuccess from './views/account/RegisterSuccess.vue'
import Login from './views/account/Login.vue'
import ForgotPassword from './views/account/ForgotPassword.vue'
import ForgotPasswordConfirmation from './views/account/ForgotPasswordConfirmation.vue'
import ResetPassword from './views/account/ResetPassword.vue'
import ResetPasswordSuccess from './views/account/ResetPasswordSuccess.vue'
import ManageUsers from './views/admin/ManageUsers.vue'
import NotFound from './components/NotFound.vue'
import ResetPasswordLoggedIn from './views/account/ResetPasswordLoggedIn.vue'
import ResetPasswordSuccessLoggedIn from './views/account/ResetPasswordSuccessLoggedIn.vue'

import ContentPage from './views/content-management/Content.vue'

import Search from './views/search/Search.vue'

Vue.use(BootstrapVue);
Vue.use(VeeValidate);
VeeValidate.Validator.extend('verify_password', {
  getMessage: `The password must be at least 8 characters and contain at least: 1 uppercase letter, 1 lowercase letter, 1 number, and one special character (E.g. , . _ & ? etc)`,
  validate: value => {
      var strongRegex = new RegExp("^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#$%^&*])(?=.{8,})");
      return strongRegex.test(value);
  }
});

//Configure axios...
if (window.location.origin === 'http://localhost:3000') {
  axios.defaults.baseURL = 'http://localhost:62737';
} else {
  axios.defaults.baseURL = window.location.origin;
}

axios.defaults.headers.common['Authorization'] = 'Bearer ' + TokenService.getToken();

axios.interceptors.response.use(
  response => response,
  error => {
      const {status} = error.response;
      if (status === 401) {
        TokenService.removeToken();
      }
      return Promise.reject(error);
 }
);

Vue.config.productionTip = false

// This callback runs before every route change, including on page load.
router.beforeEach((to, from, next) => {
  // This goes through the matched routes from last to first, finding the closest route with a title.
  // eg. if we have /some/deep/nested/route and /some, /deep, and /nested have titles, nested's will be chosen.
  const nearestWithTitle = to.matched.slice().reverse().find(r => r.meta && r.meta.title);

  // If a route with a title was found, set the document (page) title to that value.
  if (nearestWithTitle) document.title = nearestWithTitle.meta.title;

  next();
});

// IE 11 hates router links...
// https://github.com/vuejs/vue-router/issues/1911#issuecomment-434332832
const IE11RouterFix = {
  methods: {
      hashChangeHandler: function() { this.$router.push(window.location.hash.substring(1, window.location.hash.length)); },
      isIE11: function() { return !!window.MSInputMethodContext && !!document.documentMode; }
  },
  mounted: function() { if ( this.isIE11() ) { window.addEventListener('hashchange', this.hashChangeHandler); } },
  destroyed: function() { if ( this.isIE11() ) { window.removeEventListener('hashchange', this.hashChangeHandler); } }
};

axios.get('api/webtabs/tree').then(response => {
  
  function generateRoute(tab, path, contents) {
    path = path + '/' + tab.Name;
    if (tab.Children && tab.Children.length === 0) {
      contents.push({ 
        path: path.trim().replace(/\(/g, '%28').replace(/\)/g, '%29'), 
        name: tab.Id,
        title: tab.Name 
      });
      return;
    }

    for (let subTab of tab.Children) {
      generateRoute(subTab, path, contents);
    }
  }

  const contents = [];
  const tabs = response.data;
  for (let tab of tabs) {
    generateRoute(tab, '', contents)
  }

  const contentRoutes = contents.map(content => ({
    path: content.path,
    name: content.name,
    component: ContentPage,
    meta: { title: content.title , public: false, isContent: true }
  })) 

  const staticRoutes =   [
    // root route
    {
      path: '/',
      name: 'home',
      component: Home,
      meta: { title: 'Vesta', public: true }
    },

    {
      path: '/Search/:text',
      name: 'search',
      component: Search,
      meta: { title: 'Vesta - Search', public: false}
    },

    {
      path: '/Home',
      name: 'homeLoggedIn',
      component: HomeLoggedIn,
      meta: { title: 'Vesta', public: true, isContent: true}
    },

    {
      path: '*',
      component: NotFound,
      meta: {title: 'Page Not Found', public: true}
    },

    // Public Pages...
    {
      path: '/Register',
      component: Register,
      name: 'register',
      meta: { title: 'Vesta - Register', public: true, onlyWhenLoggedOut: true}
    },
    {
      path: '/RegisterSuccess',
      component: RegisterSuccess,
      name: 'register-success',
      meta: { title: 'Vesta - Register Success', public: true, onlyWhenLoggedOut: true }
    },
    {
      path: '/Login',
      component: Login,
      name: 'Login',
      meta: { title: 'Vesta - Login', public: true, onlyWhenLoggedOut: true }
    },
    {
      path: '/ForgotPassword',
      component: ForgotPassword,
      name: 'ForgotPassword',
      meta: { title: 'Vesta - Forgot Password', public: true, onlyWhenLoggedOut: true }
    },
    {
      path: '/ForgotPasswordConfirmation',
      component: ForgotPasswordConfirmation,
      name: 'ForgotPasswordConfirmation',
      meta: { title: 'Vesta - Forgot Password Confirmation', public: true, onlyWhenLoggedOut: true }
    },
    {
      path: '/ResetPassword/:code',
      component: ResetPassword,
      name: 'ResetPassword',
      meta: { title: 'Vesta - ResetPassword', public: true, onlyWhenLoggedOut: true }
    },
    {
      path: '/ResetPasswordSuccess',
      component: ResetPasswordSuccess,
      name: 'ResetPasswordSuccess',
      meta: { title: 'Vesta - Reset Password Success', public: true, onlyWhenLoggedOut: true }
    }, 
    /**  Account Views */
    {
      path: '/Admin/ManageUsers',
      name: 'ManageUsers',
      component: ManageUsers,
      meta: { title: 'Manage Users', public: false, requiresAdminRole: true }
    },
    {
      path: '/Admin/PageEditor',
      name: 'PageEditor',
      component: PageEditor,
      meta: { title: 'Page Editor', public: false, requiresAdminRole: true }
    },
    {
      path: '/Admin/SearchLog',
      name: 'SearchLog',
      component: SearchLog,
      meta: { title: 'SearchLog', public: false, requiresAdminRole: true }
    },
    {
      path: '/ResetPasswordLoggedIn',
      component: ResetPasswordLoggedIn,
      name: 'ResetPasswordLoggedIn',
      meta: { title: 'Vesta - Reset Password', public: false, onlyWhenLoggedOut: false }
    },
    {
      path: '/ResetPasswordSuccessLoggedIn',
      component: ResetPasswordSuccessLoggedIn,
      name: 'ResetPasswordSuccessLoggedIn',
      meta: { title: 'Vesta - Reset Password Successful', public: false, onlyWhenLoggedOut: false }
    },
  ];

  router.addRoutes(staticRoutes.concat(contentRoutes));

  new Vue({
    store,
    router,
    mixins: [IE11RouterFix],
    render: h => h(App)
  }).$mount('#app')
});